import { render } from "./ArchiveHeaderWithSlots.vue?vue&type=template&id=9c765600"
import script from "./ArchiveHeaderWithSlots.vue?vue&type=script&lang=js"
export * from "./ArchiveHeaderWithSlots.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__